export const technicianFileTabs = [
  {
    id: 'details',
    title: 'Details',
  },
  {
    id: 'notes',
    title: 'Notes',
  },
  {
    id: 'jobs',
    title: 'Jobs',
  },
  {
    id: 'tickets',
    title: 'Tickets',
  },
];
